import styled from "styled-components";

const Container = styled.section`
  width: 94%;
  max-width: 120rem;
  margin: auto;
  height: 100%;
`;

export default Container;
